<p>{{ 'productsStep.bkgTripInfoReturnFlight.addReturnFlight' | translate }}</p>
<input
  type="text"
  [formControl]="inputControl"
  placeholder="{{
    'productsStep.bkgTripInfoReturnFlight.returnFlight' | translate
  }}"
  class="form-item"
/>
